import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Pairing Mode",
  date: new Date(2024, 0, 7),
  img: "/img/arthur.jpeg",
  video: "/videos/arthur.mp4",
  tracks: [
    {
      title: "Cherries & Cream",
      src: "/songs/2024-01-07/cherries_and_cream.mp3",
      duration: 575.016,
    },
    {
      title: "Friend Fetish",
      src: "/songs/2024-01-07/friend_fetish.mp3",
      duration: 639.648,
    },
    {
      title: "Lonesome When You Go",
      src: "/songs/2024-01-07/lonesome_when_you_go.mp3",
      duration: 958.08,
    },
    {
      title: "Free Radicals",
      src: "/songs/2024-01-07/free_radicals.mp3",
      duration: 1218.936,
    },
    {
      title: "I Wanna Be Bayou",
      src: "/songs/2024-01-07/i_wanna_be_bayou.mp3",
      duration: 796.512,
    },
    {
      title: "Spiders From Mars!",
      src: "/songs/2024-01-07/spiders_from_mars.mp3",
      duration: 701.232,
    },
    {
      title: "Catch Me If You Can",
      src: "/songs/2024-01-07/catch_me_if_you_can.mp3",
      duration: 1117.176,
    },
    {
      title: "Gather 'Round",
      src: "/songs/2024-01-07/gather_round.mp3",
      duration: 590.472,
    },
    {
      title: "Unpack This Heavy Load",
      src: "/songs/2024-01-07/unpack_this_heavy_load.mp3",
      duration: 628.608,
    },
    {
      title: "King Arthur Wasn't Real",
      src: "/songs/2024-01-07/king_arthur_wasnt_real.mp3",
      duration: 1697.952,
    },
  ],
};
export default album;
